import QuestionItem from "components/questions/QuestionItem";
import Separator from "components/shared/Separator";
import { Fragment } from "react";

const mainClass = "help-question-list";
const noSeparatorModifiers = ["related-questions"];

const QuestionList = ({ questions, modifier }) => {
	return (
		<div className={`${mainClass}__container`}>
			<ul className={`${mainClass}__list`}>
				{questions.map((module, i) => {
					return (
						<Fragment key={i}>
							<li
								className={`${mainClass}${
									modifier ? `__${modifier}` : ""
								}__item`}
							>
								<QuestionItem modifier={modifier} module={module} />
							</li>
							{i < questions.length - 1 &&
								!noSeparatorModifiers.some((mod) => mod === modifier) && (
									<Separator />
								)}
						</Fragment>
					);
				})}
			</ul>
		</div>
	);
};

export default QuestionList;
